<template>
  <section class="app-main">
    <div class="top-bar">
      <el-date-picker
        v-model="coupon.fixDate"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px; margin-right: 15px"
      ></el-date-picker>
      <el-input
        placeholder="输入退款编号/订单号"

        v-model="searchVal"
        @change="search"
        style="width: 240px; margin-left: 20px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-radio-group
        size="mini"
        v-model="coupon.periodType"
        @change="search"
        style="display: block; margin-top: 20px"
      >
        <el-radio label="">全部</el-radio>
        <el-radio label="0">审核中</el-radio>
        <el-radio label="1">已通过</el-radio>
        <el-radio label="2">未通过</el-radio>
      </el-radio-group>
    </div>
    <!-- 商品列表 -->
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="tableChange"
        height="600"
        style="width: 100%"
      >
        <el-table-column
          prop="created_at"
          label="申请时间"
          align="center"
          min-width="140"
        >
        </el-table-column>
        <el-table-column
          prop="contact_number"
          label="联系方式"
          align="center"
          min-width="180"
        >
        </el-table-column>
        <el-table-column
          prop="order_title"
          label="订单号"
          align="center"
          min-width="185"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          label="退款编号"
          align="center"
          min-width="185"
        ></el-table-column>
        <!-- <el-table-column prop="phone" label="联系人"  align="center"  min-width="160">
                    <template slot-scope="scope">
                        <el-button type="text">{{scope.row.contacts}}-{{scope.row.contact_number}}</el-button>
                    </template>
                </el-table-column> -->
        <el-table-column prop="way" label="购买途径" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.way == 1">线下门店</span>
            <span v-else>线上商城</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_method_title" label="申请方式" align="center">
          <template slot-scope="scope">
            <el-link type="warning" v-if="scope.row.mode == 4">仅退款</el-link>
            <el-link type="primary" v-if="scope.row.mode == 3">换货</el-link>
            <el-link type="success" v-if="scope.row.mode == 2"
              >补发商品</el-link
            >
            <el-link type="warning" v-if="scope.row.mode == 1"
              >退货退款</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="reason"
          label="申请理由"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="shops_title"
          label="所属商家"
          align="center"
          min-width="110"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="audit_status_title"
          label="售后状态"
          align="center"
        >
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.audit_status_title == '审核中'" >
            {{scope.row.audit_status_title}}
          </el-link>
          <el-link  type="success"  v-if="scope.row.audit_status_title == '已通过'">
            {{scope.row.audit_status_title}}
          </el-link>
          <el-link type="danger" v-if="scope.row.audit_status_title == '已拒绝'" >
            {{scope.row.audit_status_title}}
          </el-link>
        </template>
        </el-table-column>
        <el-table-column prop="total_goods_price" label="商品总计" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.order_logistics.country == 507 ? 'US$' : 'C$'}}{{scope.row.total_goods_price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_tax_price" label="税费总计" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.order_logistics.country == 507 ? 'US$' : 'C$'}}{{scope.row.total_tax_price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="订单总计" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.order_logistics.country == 507 ? 'US$' : 'C$'}}{{scope.row.total_price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_amount" label="订单详情" align="center">
          <template slot-scope="scope">
            <el-button
              @click="showDetail(scope.row)"
              type="danger"
              plain
              size="mini"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next"
        style="padding: 15px"
        :total="total"
        :page-size="20"
      ></el-pagination>
    </el-card>

    <!-- 展开商品详情弹框 -->
    <el-dialog
      title="售后详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1200px"
    >
      <el-card class="m-bottom-2">
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >退款编号：{{ detail.title }}</el-col
          >
          <el-col :span="12" class="row-height"
            >申请时间：{{ detail.created_at }}</el-col
          >
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >联 系 人：{{ detail.contacts }}</el-col
          >
          <el-col :span="12" class="row-height"
            >联系方式：{{ detail.contact_number }}</el-col
          >
        </el-row>
        <el-row class="row-height"
          >退货方式 ：{{
            detail.return_mode == 1 ? "自行送回" : "邮寄送回"
          }}</el-row
        >
      </el-card>
      <el-card class="m-bottom-2" v-if="detail.title">
        <p
          style="
            line-height: 40px;
            color: #666;
            font-size: 16px;
            border-bottom: 1px solid #e0e0e0;
            text-align: center;
          "
        >
          商品信息 ({{
            detail.is_after_sales_all == 1 ? "全部订单" : "部分订单"
          }})
        </p>
        <el-table :data="detail.order_goods_all" max-height="300">
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <m-img
                v-if="scope.row.goods_sku_pic_url"
                :src="scope.row.goods_sku_pic_url
                "
              />
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            show-overflow-tooltip
            align="center"
            width="200"
          >
            <template slot-scope="scope">{{ scope.row.goods_name }}</template>
          </el-table-column>
          <el-table-column
            label="商品规格"
            align="center"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.sku_name }}</template>
          </el-table-column>
          <el-table-column label="条形码" align="center">
            <template slot-scope="scope">{{ scope.row.barcode }}</template>
          </el-table-column>
          <el-table-column label="退款数量" align="center">
            <template slot-scope="scope">{{ scope.row.after_sales_number }}</template>
          </el-table-column>
          <el-table-column label="商品总计" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.goods_price }}</template>
          </el-table-column>
          <el-table-column label="税费总计" align="center">
            <template slot-scope="scope">{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.goods_tax_price }}</template>
          </el-table-column>
          <!-- <el-table-column label="PST" align="center">
            <template slot-scope="scope">{{ scope.row.pst_amount }}</template>
          </el-table-column>
          <el-table-column label="GST" align="center">
            <template slot-scope="scope">{{ scope.row.gst_amount }}</template>
          </el-table-column>
          <el-table-column label="HST" align="center">
            <template slot-scope="scope">{{ scope.row.hst_amount }}</template>
          </el-table-column>
          <el-table-column label="QST" align="center">
            <template slot-scope="scope">{{ scope.row.qst_amount }}</template>
          </el-table-column> -->
        </el-table>
        <el-row class="row-height" style="margin-top: 20px">
          <span class="row-span"
            >商品价格：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.total_goods_price }}
          </span>
          <span class="row-span" v-if="detail.total_tax_price != '0.00'"
            >税费总计：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.total_tax_price }}
          </span>
          <span class="row-span">运费：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.total_freight_price }}</span>
          <span class="row-span">钱包总计：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.total_wallet_price }}</span>
          <span class="row-total">支付总价：{{detail.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ detail.total_price }}</span>
        </el-row>
      </el-card>
      <el-card v-if="detail.title" class="m-bottom-2">
        <el-row class="row-height m-bottom-2"
          >问题描述：{{ detail.describe }}</el-row
        >
        <el-row v-if="detail.describe_pic && detail.describe_pic != 0">
          <m-img :src="detail.describe_pic_url" :width="160" :height="160" />
        </el-row>
      </el-card>
      <el-card v-if="detail.audit_status == 0">
        <el-row type="flex" justify="center">
          <el-button
            type="danger "
            style="margin-right: 30px; width: 120px"
            @click="reason_modal = true"
            >拒绝申请</el-button
          >
          <el-button
            type="success"
            style="margin-left: 30px; width: 120px"
            @click="handleSubmit(1)"
            :disabled="disabled"
            >通过申请</el-button
          >
        </el-row>
      </el-card>
    </el-dialog>

    <el-dialog
      width="600px"
      title="拒绝原因"
      :visible.sync="reason_modal"
      center
      append-to-body
    >
      <el-row
        class="row-height m-bottom-4"
        type="flex"
        justify="center"
        style="line-height: 40px"
      >
        拒绝原因：
        <el-input
          placeholder="输入拒绝原因"
          v-model="reason"
          style="width: 300px"
        ></el-input>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button
          type="info "
          style="margin-right: 30px; width: 120px"
          @click="reason_modal = false"
          >取消</el-button
        >
        <el-button
          type="success"
          style="margin-left: 30px; width: 120px"
          @click="handleSubmit(2)"
          :disabled="disabled"
          >确定</el-button
        >
      </el-row>
    </el-dialog>
  </section>
</template>



<script>
import { aftersale, aftersale_handle } from "@/api/order.js";
import MImg from "./../../../components/Image";
export default {
  components: { MImg },
  data() {
    return {
      searchVal: "",
      tableData: [],
      ids: [],
      total: 0,
      page: 1,
      size: 10,
      disabled: false,
      detail_modal: false,
      detail: {},

      reason_modal: false,
      reason: "",

      coupon: {
        // 日期区间
        fixDate: "",
        // 单选
        periodType: "",
      },
    };
  },
  methods: {
    search() {
      this.page = 1;
      this.getData();
    },
    // 日期查询搜索
    handleDate(){
        this.page = 1;
        this.getData();
    },
    getData() {
      this.tableData = [];
      let params = {
        page: this.page,
      };
      if (this.searchVal != "") {
        params.title_search = this.searchVal;
        this.coupon.fixDate = [];
      }
      if (this.coupon.fixDate && this.coupon.fixDate.length != 0) {
        params.start_date = this.coupon.fixDate[0];
        params.end_date = this.coupon.fixDate[1];
      }
      if (this.coupon.periodType != "") {
        params.audit_status = this.coupon.periodType;
      }
      aftersale(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page;
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },

    // 获取订单详情
    showDetail(row) {
      this.detail = row;
      this.detail_modal = true;
    },

    // 处理售后
    handleSubmit(status) {
      let params = {
        status: status,
        id: this.detail.id,
      };
      if (status == 2) {
        if (this.reason == "") {
          this.$message({ type: "success", message: "请输入拒绝原因" });
          return false;
        } else {
          params.refuse_reason = this.reason;
        }
      }
      this.disabled = true;
      aftersale_handle(params)
        .then((res) => {
          if (res) {
            this.$message({ type: "success", message: res.msg });
            this.getData();
            this.disabled = false;
            this.detail_modal = false;
            this.reason_modal = false;
          }
        })
        .finally(() => {
          this.reason_modal = false;
          this.disabled = false;
        });
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
section {
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 15px;
    }
    .row-total {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 30px 10px 0;
    }
  }
}
</style>

